import { useTranslation } from "@equiem/web-ng-lib";
import { ProgressCircle } from "@equiem/web-ng-lib";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTrendingContentQuery } from "../hooks/useTrendingContentQuery";
import { EventCard } from "./events/EventCard";
import { NewsCard } from "./news/NewsCard";

interface Props {
  excludeUuid: string;
}

const MAX_CONTENT_DISPLAY = 3;
// We want to exclude same uuid if there is one.
const MAX_CONTENT_QUERY = MAX_CONTENT_DISPLAY + 1;

export const TrendingContent: React.FC<Props> = ({ excludeUuid }) => {
  const { t } = useTranslation();

  const { loading, data } = useTrendingContentQuery(MAX_CONTENT_QUERY);

  if (loading) {
    return <div className="text-center py-3"><ProgressCircle size="lg" /></div>;
  }

  if (data == null) {
    return null;
  }

  const cards = data.trendingContentFeed.edges
    .flatMap((c) => {
      if (
        c.__typename !== "NewsEdge" &&
        c.__typename !== "EventOccurrenceEdge"
      ) {
        return [];
      }
      if (c.node == null || c.node.uuid === excludeUuid) {
        return [];
      }

      switch (c.node.__typename) {
        case "NewsPost":
          return [
            <Col key={c.node.uuid} md="4">
              <NewsCard newsPost={c.node}></NewsCard>
            </Col>,
          ];
        case "Occurrence":
          return [
            <Col key={c.node.uuid} md="4">
              <EventCard occurrence={c.node}></EventCard>
            </Col>,
          ];
        default:
          return [];
      }
    })
    .slice(0, MAX_CONTENT_DISPLAY);

  if (cards.length === 0) {
    return null;
  }

  return (
    <div className="trending-yo pt-3 pb-5">
      <h3 className="h5 text-center">{t("main.hereIsWhatIsTrending")}</h3>
      <Container className="pt-3">
        <Row>{cards}</Row>
      </Container>
    </div>
  );
};
